import { Pret } from './pret';
import { Personne } from './personne';
import { Garantie } from './garantie';
import { environment } from '../environments/environment';
import { Information } from './information';

export class Formulaire {

  public codeApporteur = environment.codeApporteur;
  public identifiantInterne: string;
  public distributor: String;
  public prets: Pret[] = [];
  public information: Information = new Information();
  public personnes: Personne[] = [];
  public garanties: Garantie[] = [];
  public pricingInfos: any;
  public leadCreator: string;

}



// WEBPACK FOOTER //
// ./src/app/formulaire.ts